import { useState, useRef, useEffect } from "react";
import PageHeader from "../../components/PageHeader";
import PackageCards from "../../sections/PackageCards";
import WhatItMeans from "../../sections/WhatItMeans";
import ServiceTypes from "../../sections/ServiceTypes";
import ServicesGrid from "../../sections/ServicesGrid";
import Comparison from "../../sections/Comparison";
import DecisionGuideSection from "../../sections/DecisionGuideSection";
import Contact from "../../sections/Contact";

export default function Services() {
  const [selectedPackage, setSelectedPackage] = useState<string>("");
  const contactRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    document.title = "Services | BNB Cleaning";
  }, []);

  useEffect(() => {
    if (selectedPackage && contactRef.current) {
      setTimeout(() => {
        contactRef.current?.scrollIntoView({ behavior: "smooth", block: "start" });
      }, 100);
    }
  }, [selectedPackage]);

  const handleSelectPackage = (packageType: string) => {
    setSelectedPackage(packageType);
  };

  return (
    <>
      {/* <PageHeader 
        title="BNB Turnover Cleaning in Toronto"
        subtitle="Additional services available upon request."
        bgcolor="background.default"
      /> */}
      <WhatItMeans bgcolor="background.paper" />
      <PackageCards 
        bgcolor="background.default" 
        onSelectPackage={handleSelectPackage}
      />
      
      {selectedPackage && (
        <div ref={contactRef}>
          <Contact 
            bgcolor="background.paper" 
            preselectedPackage={selectedPackage} 
          />
        </div>
      )}
      {/* <ServiceTypes bgcolor="background.paper" /> */}
      <ServicesGrid 
        bgcolor="background.paper"
        onGetQuote={handleSelectPackage}
      />
      <Comparison bgcolor="background.default" />
      <DecisionGuideSection bgcolor="background.default" />
    </>
  );
}
